<template lang="pug">
EcreativTemplatesMain2
  template(#introducing)
    EcreativOrganismsPresentingIntroAndCallToLearnMore2(:headingText="introData?.headingText" :paragraphText="introData?.paragraphText" :buttonText="introData?.buttonText")
  template(#slider)
    EcreativOrganismsPresentingLatestArticlesSliderAndCallToLearnMore(:articles="sliderArticles")
  template(#searchBar)
    EcreativMoleculesSearchBar
  template(#readSection)
    EcreativOrganismsPresentingReadResources(
      :articles="injectedArticles"
      :links="beliefsLinks"
    )
  template(#watchSection)
    EcreativOrganismsPresentingWatchResources(:articles="injectedArticles")
  template(#meetSection)
    EcreativOrganismsPresentingMeetResources
  template(#joinSection)
    EcreativOrganismsPresentingJoinResources
  template(#latestArticles)
    EcreativOrganismsPresentingLatestArticlesAndCallToLoadMore(:articles="injectedArticles")
  template(#introV2)
    EcreativOrganismsExpandableMediaArticleV2(
      :title="messiahInfo?.title"
      :caption="messiahInfo?.caption"
      :content="messiahInfo?.content"
      :imageSrc="messiahInfo?.imageSrc"
      :imageAlt="messiahInfo?.imageAlt"
      :introText="messiahInfo?.introText"
      :learnMoreText="messiahInfo?.learnMoreText"
    )
</template>

<script setup lang="ts">
/* eslint-disable */
/* global definePageMeta */
import { useFetch, useHead } from '#imports';
import type { NavigationNode } from 'data-types-config';
import { inject, ref } from 'vue';

definePageMeta({
  layout: 'home',
});

const sliderArticles = inject('latestArticles', ref([]));
const injectedArticles = inject('articlesData', ref([]));
const beliefsLinks = inject<NavigationNode[]>('beliefsLinks', []);

const { data: messiahInfo } = await useFetch('/api/messiah');
const { data: introData } = await useFetch('/api/intro');

useHead({
  title: 'Introducing Ahmadiyyat',
});
</script>
